import * as THREE from 'three';

let mouseHelper;

export const addMouseHelper = (scene) => {
    var helperMaterial = new THREE.MeshBasicMaterial({ color: 0x94423d });
    helperMaterial.transparent = true;
    helperMaterial.opacity = 0.2;
    var helperGeometry = new THREE.CircleBufferGeometry(0.2, 64);
    mouseHelper = new THREE.Mesh(helperGeometry, helperMaterial);

    var ringMaterial = new THREE.MeshBasicMaterial({ color: 0x94423d });
    ringMaterial.transparent = true;
    ringMaterial.opacity = 0.8;
    var ringGeometry = new THREE.RingBufferGeometry(0.2, 0.22, 64);
    var ring = new THREE.Mesh(ringGeometry, ringMaterial);
    //ring.rotateY(0, 1.57, 1.57)
    mouseHelper.add(ring);

    mouseHelper.visible = false;

    ring.renderOrder = 2;
    mouseHelper.renderOrder = 2;

    return mouseHelper;
}